var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconYoutube3 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 30,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M24.832 6.65a3.09 3.09 0 0 1 2.176 2.176c.52 1.924.536 5.913.536 5.913s0 4.004-.52 5.912a3.1 3.1 0 0 1-2.176 2.176c-1.908.52-9.586.52-9.586.52s-7.679 0-9.586-.52A3.1 3.1 0 0 1 3.5 20.65c-.52-1.924-.52-5.912-.52-5.912s0-3.99.504-5.897A3.1 3.1 0 0 1 5.66 6.666c1.908-.52 9.586-.536 9.586-.536s7.678 0 9.586.52m-5.66 8.089-6.37 3.689v-7.379z",
  clipRule: "evenodd"
})));
export { SvgIconYoutube3 as ReactComponent };
export default __webpack_public_path__ + "cccf1a240ca7366a113cb56bd08440fa.svg";